import { AudioLines } from 'lucide-react';
import { useLocation } from 'react-router-dom';
import { useOptionalDictation, useVoiceQueueCount } from '@/components/voice/DictationContext';
import { PATIENT_FILE_RE } from './SidebarDictateButton';

/**
 * "Ditar" na barra do topo, ao lado dos microfones (pedido de 29/10/2026) —
 * no computador saiu do menu da esquerda; no celular o menu continua com o
 * dele. Só aparece na ficha de um paciente (fora dela não tem o que ditar);
 * mesmas regras e mesmo clique do `SidebarDictateButton`.
 */
export const TopbarDictateButton = () => {
  const ctx = useOptionalDictation();
  const { pathname } = useLocation();
  const patientId = PATIENT_FILE_RE.exec(pathname)?.[1] ?? null;
  const queued = useVoiceQueueCount(patientId);

  if (!ctx || !patientId) return null;

  const pill = 'relative inline-flex items-center gap-1.5 h-9 px-3 rounded-full border text-[12px] font-semibold whitespace-nowrap transition-colors';

  if (!ctx.available) {
    return (
      <button
        type="button"
        disabled
        title="Abra a ficha do paciente (aba Entradas ou Prontuário) para o ditado ficar disponível"
        className={`${pill} border-dashed border-outline-variant/40 text-on-surface-variant/50 cursor-not-allowed`}
      >
        <AudioLines size={15} className="shrink-0" />
        Ditar
      </button>
    );
  }

  return (
    <button
      type="button"
      // Abre JÁ no Ao vivo, igual ao Alt+V e ao "Ditar" do menu.
      onClick={() => ctx.open({ autoStart: 'live', origem: 'clique' })}
      title="Ditar receita, exames e cirurgia — abre já no Ao vivo; os documentos saem prontos pra conferir. Alt+V (ou pedal) liga e desliga."
      data-ditar-topo
      className={`${pill} border-primary/40 bg-primary/15 text-primary hover:bg-primary/25`}
    >
      <AudioLines size={15} className="shrink-0" />
      Ditar
      {queued > 0 && (
        <span
          className="absolute -top-1.5 -right-1 text-[10px] font-bold rounded-full bg-primary text-on-primary px-1.5 py-0.5 leading-none"
          title={`${queued} documento(s) na fila deste paciente`}
        >
          {queued}
        </span>
      )}
    </button>
  );
};
